module.exports = __webpack_public_path__ + "img/bg_home2.5a400bc7.png";